import TopChart from '@assets/icons/top-chart.svg'
import { Icon } from './Icon'

export const TopChartIcon = Icon(TopChart)
